<template>
    <div class="w100 bgGrey report-detail-box">
        <article class="wContent center">
            <div class="mw-fast-list-box" style="margin-bottom: 0; margin-top: 10px;">
                <span class="mw-fast-list-sub" @click="changeNav(0)">最新</span>
                <span class="mw-fast-list-sub" style="margin: 0" :class="{'fontBold fontRed': subNavTab == item.sortId}" v-for="(item, index) in subNav_list" :key="index" @click="changeNav(item.sortId, item.sortName)">
                    <span v-if="reportClassify[item.sortName]" class="mw-fast-list-sub">{{ reportClassify[item.sortName] }}</span>
                </span>
            </div>

            <el-row :gutter="20">
                <el-col :span="16">
                    <div class="grid-content mw-modular-box bgWhite p20">
                        <h1 class="font20">{{ detailContent.reportTitle }}</h1>
                        <div class="">
                            <span class="tag fontRed inlineBlock vMid pointer" @click="goSearchPage(table)" v-for="(table, tableI) in detailContent.sortName.split(',')" :key="tableI">{{ table == '唐宋100指数报告-分品种' || table == '唐宋100指数（周）报告' || table == '监测预警周报' || table == '唐尔街日报' ? reportClassify[table] : table }}</span> | 
                            <span class="inlineBlock vMid">{{ detailContent.reportDate }}</span>
                        </div>

                        <div class="top-text-box p20 mw-modular-box bgGrey">
                            <div class="top-text-left">
                                “
                            </div>
                            <div class="top-text-right font14">
                                {{ detailContent.abstractText }}
                            </div>
                        </div>

                        <div class="detail-content" style="height: 1415px;">
                            <iframe :src="detailContent.uploadPath" width="100%" height="100%">当前浏览器不支持， 点击此处下载: <a :href="detailContent.uploadPath">Download PDF</a></iframe>
                        </div>
                    </div>
                </el-col>
                <el-col :span="8">
                    <div class="grid-content">
                        <FastNewsControl class="mw-modular-box"></FastNewsControl>
                        <MapControl class="mw-modular-box"></MapControl>
                        <PriceIndexControl></PriceIndexControl>
                        <HotRecord class="mw-modular-box" :ad="adIDsIndex[0] ? ( adIDsIndex[0]['list'].length > 0 ? adIDsIndex[0]['list'][0]['adPicturePath'] : '') : ''" :link="adIDsIndex[0] ? ( adIDsIndex[0]['list'].length > 0 ? adIDsIndex[0]['list'][0]['adLink'] : '') : ''"></HotRecord>

                    </div>
                </el-col>
            </el-row>
        </article>
        <ConcatsControl></ConcatsControl>
    </div>
</template>

<script>
import ConcatsControl from '../../templates/concatsControl'
import FastNewsControl from '../../templates/fastNewsControl'
import MapControl from '../../templates/mapControl'
import PriceIndexControl from '../../templates/priceIndexControl'
import HotRecord from '../../templates/hotRecord'
import { baseUrl, reportClassify, navigationUrl, adIDs } from '../../assets/js/common'
export default {
    name: 'Detail',
    components: { FastNewsControl, MapControl, PriceIndexControl, HotRecord, ConcatsControl },
    data () {
        return {
            detailId: '',
            reportClassify: reportClassify,
            subNav_list: [],
            detailContent: {},
            adIDsIndex: []
        }
    },
    mounted () {
        // 初始化内容
        this.detailId = this.$route.params.id;
        this.searchReportDetail();
        this.findReportSort();
        this.getAdByAdp();
    },
    methods: {
        getAdByAdp () {
            const self = this;
            self.adIDsIndex = [{
                name: 'indexRight2',
                id: adIDs['indexRight2'],
                list: []
            }];
            self.adIDsIndex.forEach((item, index) => {
                self.$get(`${baseUrl.cyw}/industriaAD/getAdByAdp?adpId=${item.id}`, {}).then(res => {
                    if (res.code == 0) {
                        self.adIDsIndex[index]['list'] = res.data;
                    }
                })
            })
        },
        findReportSort () {
            const self = this;
            self.$get(`${baseUrl.online}/industria/reportSort/findReportSortByUserFormat`, {}).then(res => {
                if (res.code == 0) {
                    self.subNav_list = res.data;
                } else {
                    self.$message.error(res.message);
                }
            }).catch(err => {
                self.$message.error('未获取到分类信息')
            })
        },
        // 获取详情
        searchReportDetail () {
            const self = this;
            self.$post(`${baseUrl.online}/industria/report/searchReport/1/1`, { reportId: self.detailId }).then(res => {
                if (res.code == 0) {
                    self.detailContent = res.data[0]
                } else {
                    self.$message.error(res.message);
                }
            }).catch(err => {
                self.$message.error('获取详情失败');
            })
        },

        // 页面跳转
        changeNav (id) {
            this.$router.push(`${navigationUrl['研报']}?id=${id}`);
        },
        goSearchPage (name) {
            this.$router.push(`/home/searchPage?key=${name}&type=2`);
        },
    },
}
</script>

<style scoped>
    @import url('detail.css');
</style>